import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AskPodDowntimePopupInterface, AskPodDowntimePopupModel } from './askpod-downtime-popup.model';

@Component({
    selector: 'app-askpod-downtime-popup',
    templateUrl: './askpod-downtime-popup.component.html',
})
export class AskPodDowntimePopupComponent {
    data: AskPodDowntimePopupModel;

    constructor(@Inject(MAT_DIALOG_DATA) popupData: AskPodDowntimePopupInterface) {
        this.data = new AskPodDowntimePopupModel(popupData || ({} as AskPodDowntimePopupInterface));
    }
}

// Open askPOD downtime error modal box
export function openAskPodDowntimeDialog(
    dialog: MatDialog,
    popupData?: AskPodDowntimePopupInterface
): MatDialogRef<AskPodDowntimePopupComponent, boolean> {
    const config = new MatDialogConfig();

    config.autoFocus = false;
    config.disableClose = false;
    config.maxWidth = '32.5rem';
    config.width = '90vw';
    config.panelClass = 'askpod-downtime-dialog';
    config.data = { ...popupData };

    return dialog.open(AskPodDowntimePopupComponent, config);
}
